import React from 'react';
import { AuthContext, AuthContextValue } from '@auth/AuthProvider';

const useAuth = (): AuthContextValue => {
  return React.useContext(AuthContext);
};

export default useAuth;
